import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Task, TaskMutateMask } from '../protogen/planning/service_pb';
import { TaskService } from '../task.service';

// TODO: Turn these fields true when each field is edited.
const editTaskMask: TaskMutateMask.AsObject = new TaskMutateMask()
    .setTitle(true)
    .setTaskState(true)
    .toObject();

@Component({
  selector: 'app-edit-task',
  templateUrl: './edit-task.component.html',
  styleUrls: ['./edit-task.component.scss']
})
export class EditTaskComponent implements OnInit {
  dataLoaded: boolean = false;
  formValid: boolean = false;
  task: Task.AsObject = new Task().toObject();

  constructor(private route: ActivatedRoute,
      private router: Router,
      private taskService: TaskService) {
    this.fetchTask();
  }

  ngOnInit(): void {
  }

  async onSave() {
    const response = await this.taskService.editTask(this.task, editTaskMask);
    this.router.navigateByUrl(`task/${response.id}`);
  }

  onStatusChanged(status: boolean) {
    this.formValid = status;
  }

  private async fetchTask() {
    const taskId = this.route.snapshot.paramMap.get('taskId');
    if (taskId) {
      this.dataLoaded = true;
      this.task = await this.taskService.getTask(taskId);
    }
  }
}
